import Vue from 'vue';
import Router from 'vue-router';

const _import = require('./_import_' + process.env.NODE_ENV);
Vue.use(Router);

export const constantRouterMap = [
  {
    path: '/',
    redirect: '/layout',
  },
  {
    path: '/login',
    component: _import('bone/login/index'),
  },
  {
    path: '/layout',
    component: _import('bone/layout/Layout2'),
    redirect: 'o_checker',
    children: [
      /******************* 检测机构管理 ************************/
      {
        path: '/o_checker',
        component: _import('views/check_organization/o_checker/index'),
        // component: _import('views/check_organization/o_managerbak/index'),
      },
      {
        path: '/o_checker_card',
        component: _import('views/check_organization/o_checker_card/index'),
        // component: _import('views/check_organization/o_checker_card/index'),
      },
      {
        path: '/professer',
        component: _import('views/check_organization/professer/index'),
        // component: _import('views/check_organization/professer/index'),
      },
      {
        path: '/db_check',
        component: _import('views/check_organization/db_check/index'),
      },
      {
        path: '/db_check_info',
        component: _import('views/check_organization/db_check/index2'),
      },
      /********************** 风险检测管理 ********************/
      {
        path: '/check_manager',
        component: _import('views/risk_monitoring/check_manager/index'),
      },
      {
        path: '/project_management',
        component: _import('views/risk_monitoring/project_management/index'),
      },
      {
        path: '/pick_check_management',
        component: _import('views/risk_monitoring/pick_check_management/index'),
      },
        {
            path: '/pick_management',
            component: _import('views/risk_monitoring/pick_management/index'),
        },
      {
        path: '/pick_management2',
        component: _import('views/risk_monitoring/pick_management/index2'),
      },
      {
        path: '/plan_manager',
        component: _import('views/risk_monitoring/plan_manager/index'),
      },
      {
        path: '/finish_info',
        component: _import('views/risk_monitoring/finish_info/index'),
      },
      /**************** 基础信息管理 ***************/
      {
        path: '/std_produce',
        component: _import('views/basic_information/std_produce/index'),
      },
      {
          path: '/std_produce_item',
          component: _import('views/basic_information/std_produce/index2'),
      },
      {
        path: '/o_manager',
        component: _import('views/basic_information/o_manager/index'),
      },
      {
        path: '/o_need_check',
        component: _import('views/basic_information/o_need_check/index'),
      },
      {
        path: '/std_judge',
        component: _import('views/basic_information/std_judge/index'),
      },
        {
            path: '/std_judge_item',
            component: _import('views/basic_information/std_judge/index2'),
        },
      {
        path: '/std_limit',
        component: _import('views/basic_information/std_limit/index'),
      },
        {
            path: '/std_limit_item',
            component: _import('views/basic_information/std_limit/index2'),
        },
      {
        path: '/std_bad_dic',
        component: _import('views/basic_information/std_bad/dic'),
      },
        {
            path: '/std_bad',
            component: _import('views/basic_information/std_bad/index'),
        },
        {
            path: '/std_bad_item',
            component: _import('views/basic_information/std_bad/itemIndex'),
        },
      {
        path: '/o_pick_tmpl',
        component: _import('views/basic_information/o_pick_tmpl/index'),
      },
      {
        path: '/component_table',
        component: _import('components/Table/index'),
      },
      {
        path: '/component_edit_form',
        component: _import('components/Table/index'),
      },
      {
        path: '/component_info_form',
        component: _import('components/Table/index'),
      },
        {
            path: '/system/user-manage',
            component: _import('views/system/user-manage/index'),
        },
        {
            path: '/system/role-manage',
            component: _import('views/system/role-manage/index'),
        },
    ],
  },
  {
    path: '*',
    redirect: '/login',
  },
];

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: constantRouterMap,
});
